import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={7} className="m-auto text-center">
            <h3 className="h3_head">
              Cutting-Edge <span>Tech Stack for B2B</span> Portal Development
            </h3>
            <p>
              Our B2B portal solutions are built with the most advanced and
              in-demand technologies, ensuring optimal performance, scalability,
              and security throughout every phase of development.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/frontend/Html_5.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Html 5</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/frontend/Css_3.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Css 3</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/frontend/angular.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Angular</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/frontend/Js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/frontend/React.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>React</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/frontend/vue_js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Vue JS</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/backend/Django.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Django</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/backend/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/backend/Php.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Php</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/backend/Python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/backend/Ruby_on_Rails.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Ruby on Rails</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/my_sql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/database/Radis.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Radis</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Cloud">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/google_cloud_platform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/woocommerce/cloud/kubernets.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>kubernets</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/cloud/Jenkins.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="API">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/api/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/api/Oauth.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Oauth</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/api/RESTful_APIs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Restful APIs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/b2b-portal/api/Soap.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Soap</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
